import React from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";

const DocumentViewerUI = ({docs} : {docs : Array<{uri: string}>}) => {
    return (
        <DocViewer
            documents={docs}
            pluginRenderers={DocViewerRenderers}
            config={{
                header: {
                    disableHeader: true,
                },

                pdfZoom: {
                    defaultZoom: 1.5,
                    zoomJump: 0.2,
                },
                pdfVerticalScrollByDefault: true
            }}
        />
    )
}

export default DocumentViewerUI;